import React, { FC } from 'react';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';

import block from './block.json';
import { getStyles } from './styles.css';

/**
 * TYPINGS
 */
export type ParagraphProps = {
	content: string;
} & ThemeProps;

/**
 * COMPONENT
 */
export const Paragraph: FC<ParagraphProps> & BlockConfigs = ({
	content,
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(block.slug, theme);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx('supt-paragraph', getStyles(blockTheme));

	return (
		<p
			className={rootClass}
			dangerouslySetInnerHTML={{ __html: content }}
			data-block={block.slug}
			{...htmlProps}
		/>
	);
};

Paragraph.slug = block.slug;
Paragraph.title = block.title;
